import { useEffect, useRef, useState } from 'react';
import socketIOClient from 'socket.io-client';
import axios from 'axios';
import { getGroupChatMessages, sendGroupChatMessage } from './service';

const NEW_CHAT_GROUP_MESSAGE_EVENT = "newChatGroupMessage";
//const SOCKET_SERVER_URL = "https://chat.pindogo.com/";
//const SOCKET_SERVER_URL = "http://164.92.100.121:8080/";
//const SOCKET_SERVER_URL = "https://seashell-app-upewk.ondigitalocean.app";
//const SOCKET_SERVER_URL = "http://chat.pindogo.com";
const SOCKET_SERVER_URL = "http://localhost:8080";

const useGroupChat = (currentGroupChat, authUser, setIsSocketConnected, isSocketConnected, setIncomingLastMessage, setProgressBar) => {
  const [groupMessages, setGroupMessages] = useState([]);
  const [newMsg, setNewMsg] = useState();

  const socketRef = useRef();

  const token = sessionStorage.getItem('#f8WEB#');
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  async function fetchGroupMessages() {
    if (currentGroupChat) {
      const res = await axios.get(getGroupChatMessages(currentGroupChat?.id), { headers });
      setGroupMessages(res?.data?.data);
    }
  }
  
  useEffect(() => {
    fetchGroupMessages();
  }, [currentGroupChat]);
  
  const sendMessage = async (msg) => {
    try {
      const formData = {
        message: msg,
      };

      const res = await axios.post(sendGroupChatMessage(currentGroupChat?.id), formData, { headers });
      // console.log('senderMessageObj: ', res?.data);
      // console.log('authUser: ', authUser);

      // Extract the message data from the response
    const messageData = {
        body: res?.data,
        senderId: socketRef?.current?.id,
      };
      setIncomingLastMessage(res?.data)
      // Emit the message to the node server, which will be listenned to
      socketRef.current.emit(NEW_CHAT_GROUP_MESSAGE_EVENT, messageData);

      // Message is added to the groupMessages array when received from the server
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const sendFile = async (fileData, e) => {
    try {

      // Create a new FormData object and append the file to it
      const formData = new FormData();
  
      formData.append('message', null);
      formData.append('file', fileData);
  
      const res = await axios.post(sendGroupChatMessage(currentGroupChat?.id), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress: e => {
          setProgressBar({progressValue: Math.round(100 * e.loaded) / e.total, groupId: currentGroupChat.id})
        }
      });
      //console.log('resFileData: ', res?.data);
      
      // Create the message object to send via socket
      const messageData = {
        body: res?.data,
        senderId: socketRef?.current?.id,
      };

      setIncomingLastMessage(res?.data)
  
      // Emit the message to the server, which will be listenned to here again below
      socketRef.current.emit(NEW_CHAT_GROUP_MESSAGE_EVENT, messageData);
  
    } catch (error) {
      console.error("Error sending file:", error);
    }
  };

  //receivers side
  useEffect(() => {
    const groupId = currentGroupChat?.id;
    socketRef.current = socketIOClient(SOCKET_SERVER_URL, {
      query: { groupId }
    });

    socketRef.current.on("connect", () => {
      setIsSocketConnected(true);
    });

    socketRef.current.on("disconnect", () => {
      setIsSocketConnected(false);
    });

    socketRef.current.on(NEW_CHAT_GROUP_MESSAGE_EVENT, (messageData) => {
      const incomingMessage = messageData?.body
      setIncomingLastMessage(incomingMessage)
      
      setGroupMessages((messages) => [...messages, incomingMessage]);
      setNewMsg(incomingMessage);
  
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [newMsg, currentGroupChat]);

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      if (!isSocketConnected) {
        // If the socket is not connected, refresh the useEffect
        fetchGroupMessages();
      }
    }, 5000); // Adjust the interval as needed (e.g., every 5 seconds)
  
    return () => {
      clearInterval(refreshInterval);
    };
  }, [isSocketConnected]);
  

  // console.log('currentGroupChat: ', currentGroupChat?.id);
  //console.log('groupMessages: ', groupMessages);

  return { groupMessages, sendMessage, sendFile };
};

export default useGroupChat;
